/**
 * Schema Comparison Service — Smart Loader
 *
 * Selects between real API and mock implementation based on USE_BACKEND.
 */

import { USE_BACKEND } from '../config/env';
import type { SchemaComparisonService } from './schemaComparisonService.api';

async function createService(): Promise<SchemaComparisonService> {
    if (USE_BACKEND) {
        const { apiSchemaComparisonService } = await import('./schemaComparisonService.api');
        return apiSchemaComparisonService;
    } else {
        const { MockSchemaComparisonService } = await import('./schemaComparisonService.mock');
        return new MockSchemaComparisonService();
    }
}

let serviceInstance: Promise<SchemaComparisonService> | null = null;

function getService(): Promise<SchemaComparisonService> {
    if (!serviceInstance) {
        serviceInstance = createService();
    }
    return serviceInstance;
}

export const schemaComparisonService = {
    async compareSchemaWithFile(dataObjectId: string, file: File) {
        const svc = await getService();
        return svc.compareSchemaWithFile(dataObjectId, file);
    },
    async compareSchemaWithTable(dataObjectId: string, tableName: string) {
        const svc = await getService();
        return svc.compareSchemaWithTable(dataObjectId, tableName);
    },
};
